import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import styles from './TopBar.module.css';

function linkClass({ isActive }: { isActive: boolean }): string {
  return isActive ? `${styles.link} ${styles.linkActive}` : (styles.link ?? '');
}

export default function TopBar(): JSX.Element {
  const { user, signOut } = useAuth();

  return (
    <nav data-testid="top-bar" className={styles.bar} aria-label="Primary">
      <span className={styles.brand}>Ball Watcher</span>
      <NavLink to="/games" className={linkClass} end>
        Live games
      </NavLink>
      <NavLink to="/games/historical" className={linkClass}>
        Historical games
      </NavLink>
      {user && (
        <NavLink to="/comments" className={linkClass} data-testid="top-bar-comments">
          Comments
        </NavLink>
      )}
      <span className={styles.spacer} />
      {user && (
        <div className={styles.right}>
          <span className={styles.user} data-testid="top-bar-user">
            {user.displayName ?? user.email ?? user.uid}
          </span>
          <button
            type="button"
            className={styles.signOut}
            onClick={() => {
              void signOut();
            }}
            data-testid="top-bar-sign-out"
          >
            Sign out
          </button>
        </div>
      )}
    </nav>
  );
}
